// extracted by mini-css-extract-plugin
export default {"tableTitleCell":"InfoTable_tableTitleCell__tqFqi","tableInfoCell":"InfoTable_tableInfoCell__joFpa"};